import {
  REQUEST_CREATE_ROUTE_CONTROL_POINT,
  REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE,
  REQUEST_DELETE_ROUTE_CONTROL_POINT,
  REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE,
} from "../actions/routeControlPointActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  createRouteControlPointDataState: queriesStates.NOT_REQUESTED,
  deleteRouteControlPointDataState: queriesStates.NOT_REQUESTED,
  errors: [],
};

const routeControlPointReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CREATE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        createRouteControlPointDataState: queriesStates.REQUEST,
        errors: [],
      });
    }

    case REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        createRouteControlPointDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_ROUTE_CONTROL_POINT: {
      return Object.assign({}, state, {
        deleteRouteControlPointDataState: queriesStates.REQUEST,
      });
    }
    case REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE: {
      return Object.assign({}, state, {
        deleteRouteControlPointDataState: queriesStates.READY,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default routeControlPointReducer;
